import { useSelector } from 'react-redux';
import AuthState from '../../actions/auth';

const useAbilities = () => {
  const abilities = useSelector(AuthState.selectors.abilities());
  return abilities;
};

export default useAbilities;
